import React, { createContext, useEffect, useState } from 'react';

export const DeviceContext = createContext();

export const  DeviceProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [toolbarHeight, setToolbarHeight] = useState(0);


  //const toolbarHeight = getMobileBrowserToolbarHeight();
  //console.log('Mobile browser toolbar height:', toolbarHeight, 'px');

  useEffect(() => {

    const getMobileBrowserToolbarHeight = () => {
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        return window.screen.height - vh;
    };

    setToolbarHeight(getMobileBrowserToolbarHeight);
  },[]);


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1200) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    // 컴포넌트가 마운트 되었을 때와 창 크기가 변경될 때 이벤트 핸들러 실행
    handleResize();
    window.addEventListener('resize', handleResize);

    // 컴포넌트가 언마운트될 때 이벤트 핸들러 제거
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <DeviceContext.Provider value={{isMobile, toolbarHeight}}>
      {children}
    </DeviceContext.Provider>
  );
}